import { createInertiaApp } from '@inertiajs/react'
import { createElement } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import resolvePage from '../lib/resolvePage'

createInertiaApp({
  defaults: { form: { forceIndicesArrayFormatInFormData: false } },
  resolve: resolvePage,
  setup({ el, App, props }) {
    if (!el) throw new Error('Missing root element for the Inertia app')
    if (el.hasAttribute('data-server-rendered')) hydrateRoot(el, createElement(App, props))
    else createRoot(el).render(createElement(App, props))
  },
})
